import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

declare global {
  interface Window {
    ReactNativeWebView: {
      postMessage: (message: any) => void;
    };
  }
}

@Component({
  selector: 'app-checkout-notification',
  templateUrl: './checkout-notification.component.html',
  styleUrls: []
})
export class CheckoutNotificationComponent implements OnInit {

  statusNotification: string = '';
  movilFragment: string = '';
  ruta: any; // Variable para almacenar la ruta
  url: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    const snapshot = this.route.snapshot;

    // Determinar si la URL tiene parámetros
    this.url = window.location.href.includes('?');

    // Obtener `status` desde params o ruta
    this.statusNotification = snapshot.params['status'];
    this.ruta = snapshot;

    // Si no hay status válido, lo tomamos de la ruta
    if (this.statusNotification !== 'ok' && this.statusNotification !== 'ko') {
      this.statusNotification = snapshot.url[1]?.path || 'ko';
    }
    console.log("status",this.statusNotification)

    // Limpiar el fragmento
    this.movilFragment = (snapshot.fragment ?? '').split('?')[0];

    // Mapear fragmento a prefijo
    const prefixMap: { [key: string]: string } = {
      esim: 'esim',
      revoluKyc: 'docs',
      revoluPaylands: 'revolu'
    };

    for (const key in prefixMap) {
      if (this.movilFragment.includes(key)) {
        if (['ok', 'ko'].includes(this.statusNotification)) {
          this.statusNotification = `${prefixMap[key]}-${this.statusNotification}`;
        }
        break;
      }
    }

    // Fallback a 'ko' si no es válido
    if (!['ok', 'ko', 'esim-ok', 'esim-ko', 'docs-ok', 'docs-ko', 'revolu-ok', 'revolu-ko'].includes(this.statusNotification)) {
      this.statusNotification = 'ko';
    }

    console.log('ruta:', this.ruta);
    console.log('statusNotification:', this.statusNotification);
    console.log('movilFragment:', this.movilFragment);
  }


  getIconPath(): string {
    switch (this.statusNotification) {
      case 'ok':
      case 'esim-ok':
      case 'revolu-ok':
      case 'docs-ok':
        return './assets/icons/ok.svg';
      case 'ko':
      case 'esim-ko':
      case 'revolu-ko':
      case 'docs-ko':
        return './assets/icons/ko.svg';
      default:
        return './assets/icons/ko.svg';
    }
  }
  


  close() {
    // @ts-ignore
    window.ReactNativeWebView.postMessage("close")
  }
  Redirect()
  {
    if (this.statusNotification  === 'esim-ok') {
      this.router.navigate(['/my-esims']);
    }
  }

  getTitleKey(param: string): string {
    const p = param?.toUpperCase?.() || 'TITLE';

    switch (this.statusNotification) {
      case 'ok':
        return `CHECKOUT.OK.${p}`;
      case 'esim-ok':
        return `CHECKOUT.OK-ESIM.${p}`;
      case 'esim-ko':
        return `CHECKOUT.KO-ESIM.${p}`;
      case 'revolu-ok':
        return `CHECKOUT.OK-REVOLU.${p}`;
      case 'revolu-ko':
        return `CHECKOUT.KO-REVOLU.${p}`;
      case 'docs-ok':
        return `CHECKOUT.OK-KYC.${p}`;
      case 'docs-ko':
        return `CHECKOUT.KO-KYC.${p}`;
      default:
        return `CHECKOUT.KO.${p}`;
    }
  }
}
